import { render, staticRenderFns } from "./FileAgent.vue?vue&type=template&id=738da7d7&scoped=true"
import script from "./FileAgent.vue?vue&type=script&lang=js"
export * from "./FileAgent.vue?vue&type=script&lang=js"
import style0 from "./FileAgent.vue?vue&type=style&index=0&id=738da7d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738da7d7",
  null
  
)

export default component.exports